import "core-js/modules/es6.array.find.js";
import moment from 'moment';
export var openLoan = function openLoan(state) {
  return state.loans ? state.loans.find(function (loan) {
    return loan.isOpen();
  }) : null;
};
export var sortLoans = function sortLoans(state) {
  return state.loans ? state.loans.sort(function (a, b) {
    return moment(b.get('created_at')).diff(moment(a.get('created_at')));
  }) : null;
};
export var lastLoan = function lastLoan(state) {
  return state.loans ? sortLoans(state)[0] : null;
};